<div class="sample-validation-rules-form">
  @if (isLoading) {
    <div class="loading-container">
      <app-rings-loader class="bg-transparent"></app-rings-loader>
    </div>
  }

  @if (!isLoading) {
    <div class="config-container">
      <div class="intro-strip">
        <span class="material-icons intro-icon">rule</span>
        <div class="intro-text">
          <h3>{{ 'Sample Acceptance Rules' | translate }}</h3>
          <p>{{ 'Configure per-sample-type validation rules. Empty fields use the platform defaults.' | translate }}</p>
          <p class="tenant-scope-note">{{ 'This setting applies tenant-wide, not just this jurisdiction.' | translate }}</p>
        </div>
      </div>
      @for (section of sections; track trackBySampleType($index, section)) {
        <div class="rule-section">
          <div class="rule-section-header">
            <span class="section-title">{{ section.label }}</span>
            <span class="source-badge" [ngClass]="{ 'custom': section.isCustom, 'default': !section.isCustom }">
              <span class="material-icons">{{ section.isCustom ? 'tune' : 'apartment' }}</span>
              {{ (section.isCustom ? 'Custom rule' : 'Using platform defaults') | translate }}
            </span>
            <ng-container *objectHasPermission="tenantRiskPermissionObject; action: updateAction">
              @if (section.isCustom) {
                <button class="btn btn-text reset-btn" (click)="resetSection(section)">
                  <span class="material-icons">restart_alt</span>
                  {{ 'Reset to defaults' | translate }}
                </button>
              }
            </ng-container>
          </div>
          <div class="rule-fields">
            @if (!section.usesNoiseDrift) {
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Max Cal Drift' | translate }}</mat-label>
                <input matInput type="number" min="0" step="0.1" [(ngModel)]="section.maxCalDriftPercent"
                  (ngModelChange)="onSectionChange(section)" />
                  <span matTextSuffix>%</span>
                  @if (!section.errors.maxCalDriftPercent) {
                    <mat-hint>{{ 'Default: {{value}} percent' | translate: { value: defaultCalDriftPercent } }}</mat-hint>
                  }
                  @if (section.errors.maxCalDriftPercent) {
                    <mat-hint class="field-error">{{ section.errors.maxCalDriftPercent | translate }}</mat-hint>
                  }
                </mat-form-field>
              }
              @if (section.usesNoiseDrift) {
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Max Noise Drift' | translate }}</mat-label>
                  <input matInput type="number" min="0" step="0.1" [(ngModel)]="section.maxNoiseDriftDb"
                    (ngModelChange)="onSectionChange(section)" />
                    <span matTextSuffix>dB</span>
                    @if (!section.errors.maxNoiseDriftDb) {
                      <mat-hint>{{ 'Default: {{value}} dB' | translate: { value: defaultNoiseDriftDb } }}</mat-hint>
                    }
                    @if (section.errors.maxNoiseDriftDb) {
                      <mat-hint class="field-error">{{ section.errors.maxNoiseDriftDb | translate }}</mat-hint>
                    }
                  </mat-form-field>
                }
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Min Run Time' | translate }}</mat-label>
                  <input matInput type="number" min="0" step="1" [(ngModel)]="section.minRunTimeMinutes"
                    (ngModelChange)="onSectionChange(section)" />
                    <span matTextSuffix>{{ 'min' | translate }}</span>
                    @if (!section.errors.minRunTimeMinutes) {
                      <mat-hint>
                        @if (section.runTimeSecondsHelper) {
                          <span class="run-time-helper">{{ section.runTimeSecondsHelper }}</span>
                        }
                        @if (!section.runTimeSecondsHelper) {
                          <span>{{ 'No floor' | translate }}</span>
                        }
                      </mat-hint>
                    }
                    @if (section.errors.minRunTimeMinutes) {
                      <mat-hint class="field-error">{{ section.errors.minRunTimeMinutes | translate }}</mat-hint>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="required-fields-field">
                    <mat-label>{{ 'Required Fields' | translate }}</mat-label>
                    <mat-select multiple [(ngModel)]="section.requiredFields" (ngModelChange)="onSectionChange(section)">
                      @for (option of requiredFieldOptions; track trackByIndex($index)) {
                        <mat-option
                          [value]="option.value">
                          {{ option.label | translate }}
                        </mat-option>
                      }
                    </mat-select>
                    <mat-hint>{{ 'Enforced in addition to built-in required fields' | translate }}</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            }
            <div class="form-actions">
              <button class="btn btn-primary" [disabled]="!hasChanges || hasErrors" (click)="saveConfiguration()"
                *objectHasPermission="tenantRiskPermissionObject; action: updateAction">
                <span class="material-icons">save</span>
                {{ 'Save' | translate }}
              </button>
            </div>
          </div>
        }
      </div>
